/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()
